var ColumnsEditController = (function () {
    function ColumnsEditController(env, $filter, DTS, $stateParams, $state, socket, $scope, config, admin, $timeout, Dialog, $q, settings, notify) {
        var _this = this;
        this.env = env;
        this.$filter = $filter;
        this.DTS = DTS;
        this.$stateParams = $stateParams;
        this.$state = $state;
        this.socket = socket;
        this.$scope = $scope;
        this.config = config;
        this.admin = admin;
        this.$timeout = $timeout;
        this.Dialog = Dialog;
        this.$q = $q;
        this.settings = settings;
        this.notify = notify;
        this.id = '';
        this.program = '';
        this.dataLoaded = false;
        this.modified = false;
        this.modifiedItem = false;
        this.okMessage = undefined;
        this.errorMessage = undefined;
        this.enableProgramChange = true;
        this.editMain = true;
        this.editCl = true;
        this.id = $stateParams.id;
        this.program = $stateParams.program;
        this.actionList = [
            { id: undefined, desc: 'If there is no action assigned, keep this selection selected', name: 'No action' }
        ];
        this.tempCheckList = {
            pickedProgram: '',
            pickedIots: [],
            check_list: [],
            groupID: undefined,
            _rev: undefined,
            cl_rb: { desc: '', picked: '', rb: [] },
            check_list2: [],
            cl2_rb: { desc: '', picked: '', rb: [] },
            check_list3: [],
            cl3_rb: { desc: '', picked: '', rb: [] },
            check_list_validation: [],
            cl_validation_rb: { desc: '', picked: '', rb: [] },
            check_list_calculation: [],
            cl_calculation_rb: { desc: '', picked: '', rb: [] },
            check_list_opportunity_detail: [],
            cl_opportunity_detail_rb: { desc: '', picked: '', rb: [] },
            check_list_investment_review: [],
            cl_investment_rb: { desc: '', picked: '', rb: [] },
            check_list_payment: [],
            cl_payment_rb: { desc: '', picked: '', rb: [] },
            check_list_exceptions: [],
            cl_exceptions_rb: { desc: '', picked: '', rb: [] }
        };
        // Makes sure, that on leave without save, you will get a prompt
        this.$scope.$on("$locationChangeStart", function (event) {
            if (_this.modified) {
                // Only way I could do this is the blocking confirm. Its not possible with angular dialog promise
                var dialogCheck = confirm('Data not saved! Do you want to leave the page without saving? Press OK to leave page or CANCEL to stay on page');
                if (!dialogCheck) {
                    event.preventDefault();
                }
            }
        });
        // Based on what action was received data will be updated
        this.socket.forward('admin.program_checklist_edit', this.$scope);
        this.$scope.$on('socket:admin.program_checklist_edit', function (event, data) {
            if (_this.browserID === data.browserID) {
                if (data.action === 'update') {
                    if (data.success) {
                        _this.message(event, data);
                        _this.dataLoaded = true;
                        _this.$state.go('admin.checklist-view');
                    }
                    else {
                        _this.okMessage = undefined;
                        _this.errorMessage = data.msg;
                    }
                }
                else if (data.action === 'clear') {
                    if (data.success) {
                        _this.message(event, data);
                        _this.dataLoaded = true;
                        _this.$state.go('admin.checklist-view');
                    }
                    else {
                        _this.okMessage = undefined;
                        _this.errorMessage = data.msg;
                    }
                }
                else if (data.action === 'getItem') {
                    if (data.success) {
                        _this.message(event, data);
                        _this.dataLoaded = true;
                        _this.tempCheckList = data.dataUpdated;
                        _this.checkList = angular.copy(_this.tempCheckList);
                        _this.enableProgramChange = false;
                        _this.okMessage = 'checklist retreived successfully';
                        _this.errorMessage = undefined;
                    }
                    else {
                        _this.message(event, data);
                        _this.$state.go('admin.checklist-view');
                    }
                }
            }
            else {
                _this.okMessage = undefined;
                _this.errorMessage = 'Page has been left or reloaded, please reload for the changes to take effect';
            }
        });
    }
    /**
      message- Shows a red or green md-toast based on the message
      @param {any} ev       event
      @param {any} data     data containg msg and err based on error
      @returns void
    */
    ColumnsEditController.prototype.message = function (ev, data) {
        if (data.err) {
            return this.notify.error(data.msg);
        }
        this.notify.success(data.msg);
    };
    /**
      backToView- Moves back to checklist view
      @returns void
    */
    ColumnsEditController.prototype.backToView = function () {
        this.modified = false;
        this.$state.go('admin.checklist-view');
    };
    /**
      changedIot- On iot change modification is registered
      @returns void
    */
    ColumnsEditController.prototype.changedIot = function () {
        this.modified = true;
    };
    ColumnsEditController.prototype.$onInit = function () {
        var array = new Uint32Array(2);
        this.browserID = window.crypto.getRandomValues(array)[0];
        if (!(angular.isDefined(this.program) && !(this.program === 'new' || this.program === ''))) {
            this.tempCheckList.pickedProgram = this.program;
        }
        if (angular.isDefined(this.admin.config)) {
            this.admin.getGeneralConfig();
        }
        ;
        //////////this.settings.updateIot();
        if (angular.isDefined(this.id) && !(this.id === 'new' || this.id === '')) {
            this.socket.emit('module', {
                module: {
                    application: 'dmt',
                    function: 'getAdminProfile',
                    script: '/admin/admin',
                    browserID: this.browserID,
                    data: {
                        program: this.program,
                        groupID: this.id,
                        token: this.env.user.token,
                        adminComponent: 'checklist'
                    },
                    token: this.env.user.token
                }
            });
        }
        else {
            this.checkList = angular.copy(this.tempCheckList);
            this.dataLoaded = true;
        }
    };
    /**
      savePage- Confirms the changes done on the checklist edit page
      @param {IAngularEvent} event   event
      @returns void
    */
    ColumnsEditController.prototype.savePage = function (event) {
        var _this = this;
        var items = {
            message: 'Are you sure you want to Save this Profile? ',
            okMessage: 'Save',
            cancelMessage: 'Cancel',
            dialogName: 'Save checklist Profile'
        };
        this.Dialog.YesNoForm(event, items, 'yes-no.html').then(function (dResult) {
            if (dResult.confirm) {
                _this.socket.emit('module', {
                    module: {
                        application: 'dmt',
                        function: 'updateAdminData',
                        script: '/admin/admin',
                        browserID: _this.browserID,
                        data: {
                            token: _this.env.user.token,
                            groupID: _this.checkList.groupID,
                            adminComponent: 'checklist',
                            data: _this.tempCheckList
                        },
                        token: _this.env.user.token
                    }
                });
            }
        });
    };
    /**
      clearPage- Will remove the displayed profile from the cloudant document
      @param {IAngularEvent} event   event
      @returns void
    */
    ColumnsEditController.prototype.clearPage = function (event) {
        var _this = this;
        var items = {
            message: 'Are you sure you want to Delete this Profile? ',
            okMessage: 'Delete',
            cancelMessage: 'Cancel',
            dialogName: 'Delete checklist Profile'
        };
        this.Dialog.YesNoForm(event, items, 'yes-no.html').then(function (dResult) {
            if (dResult.confirm) {
                _this.socket.emit('module', {
                    module: {
                        application: 'dmt',
                        function: 'clearAdminData',
                        script: '/admin/admin',
                        browserID: _this.browserID,
                        data: {
                            program: _this.program,
                            groupID: _this.id,
                            token: _this.env.user.token,
                            adminComponent: 'checklist'
                        },
                        token: _this.env.user.token
                    }
                });
            }
        });
    };
    /**
      clearIOT- Clears the IOT selection
      @returns void
    */
    ColumnsEditController.prototype.clearIOT = function () {
        this.tempCheckList.pickedIots = [];
    };
    /**
      expand - Expands the section with checklist & radio buttons
      @param {string} name:   name of the checklist section
    */
    ColumnsEditController.prototype.expand = function (name) {
        angular.forEach(this.admin.listOfCheckList, function (cl) {
            if (cl.name === name) {
                cl.visible = true;
            }
        });
    };
    /**
      collapse - Collapses the section with checklist & radio buttons
      @param {string} name:   name of the checklist section
    */
    ColumnsEditController.prototype.collapse = function (name) {
        angular.forEach(this.admin.listOfCheckList, function (cl) {
            if (cl.name === name) {
                cl.visible = false;
            }
        });
    };
    /**
      editSection - Enables edit mode of the selected section
      @param {string} name:   name of the checklist section
    */
    ColumnsEditController.prototype.editSection = function (name) {
        var _this = this;
        angular.forEach(this.admin.listOfCheckList, function (cl) {
            if (cl.name === name) {
                _this.backupCheckList = angular.copy(_this.tempCheckList[cl.variableName]);
                _this.backupRadioButton = angular.copy(_this.tempCheckList[cl.radioButtonName]);
                cl.editView = true;
                cl.visible = true;
                _this.editMain = false;
            }
            else {
                cl.editView = false;
            }
        });
    };
    /**
      saveSection - Confirms the changes of the selected section & saves them
      @param {string} name:   name of the checklist section
    */
    ColumnsEditController.prototype.saveSection = function (name) {
        var _this = this;
        this.modifiedItem = false;
        this.modified = true;
        angular.forEach(this.admin.listOfCheckList, function (cl) {
            if (cl.name === name) {
                _this.backupCheckList = [];
                _this.backupRadioButton = { desc: '', picked: '', rb: [] };
                cl.editView = false;
                _this.editMain = true;
            }
        });
    };
    /**
      cancelSection - Retreives the checklist & radioButton object, that was stored as backup, when edit button was inserted.
      @param {string} name:   name of the checklist section
    */
    ColumnsEditController.prototype.cancelSection = function (name) {
        var _this = this;
        angular.forEach(this.admin.listOfCheckList, function (cl) {
            if (cl.name === name) {
                _this.tempCheckList[cl.variableName] = angular.copy(_this.backupCheckList);
                _this.tempCheckList[cl.radioButtonName] = angular.copy(_this.backupRadioButton);
                _this.backupCheckList = [];
                _this.backupRadioButton = { desc: '', picked: '', rb: [] };
                cl.editView = false;
                _this.editMain = true;
            }
        });
    };
    /**
      addItem - Adds a new checklist question on the end of the checklist list
      @param {string} variableName:   name of the checklist object
    */
    ColumnsEditController.prototype.addItem = function (variableName) {
        this.modifiedItem = true;
        this.editCl = false;
        this.tempCheckList[variableName].push({ q: '', answer: '', editMode: true });
        this.backupCheckListItem = angular.copy({ q: '', answer: '', editMode: false });
    };
    /**
      removeItem - Removes checklist question from the index position
      @param {string} variableName:   name of the checklist object
      @param {number} index:          position of the removed check list question
    */
    ColumnsEditController.prototype.removeItem = function (variableName, index) {
        this.modifiedItem = true;
        if (angular.isDefined(this.tempCheckList[variableName]) && this.tempCheckList[variableName].length > index) {
            this.backupCheckListItem = undefined;
            this.tempCheckList[variableName].splice(index, 1);
        }
        this.editCl = true;
    };
    /**
      saveItem - Saves the checklist in the edit mode on the index position
      @param {string} variableName:   name of the checklist object
      @param {number} index:          position of the saved check list question
    */
    ColumnsEditController.prototype.saveItem = function (variableName, index) {
        this.modifiedItem = true;
        if (angular.isDefined(this.tempCheckList[variableName]) && this.tempCheckList[variableName].length > index) {
            this.backupCheckListItem = undefined;
            this.tempCheckList[variableName][index].editMode = false;
        }
        this.editCl = true;
    };
    /**
      editItem - Enables editing of the checklist on the index position
      @param {string} variableName:   name of the checklist object
      @param {number} index:          position of the to be edited check list question
    */
    ColumnsEditController.prototype.editItem = function (variableName, index) {
        this.editCl = false;
        if (angular.isDefined(this.tempCheckList[variableName]) && this.tempCheckList[variableName].length > index) {
            this.backupCheckListItem = angular.copy(this.tempCheckList[variableName][index]);
            this.tempCheckList[variableName][index].editMode = true;
        }
    };
    /**
      cancelItem - Restores the backuped checklist question and disables edit mode
      @param {string} variableName:   name of the checklist object
      @param {number} index:          position of the check list question where to be restored from the backup
    */
    ColumnsEditController.prototype.cancelItem = function (variableName, index) {
        this.tempCheckList[variableName][index] = angular.copy(this.backupCheckListItem);
        this.backupCheckListItem = undefined;
        this.tempCheckList[variableName][index].editMode = false;
        this.editCl = true;
    };
    /**
      addItemLine - Inserts a new checklist question on the position of the index
      @param {string} variableName:   name of the checklist object
      @param {number} index:          position of the check list question where a new question will be added
    */
    ColumnsEditController.prototype.addItemLine = function (variableName, index) {
        this.modifiedItem = true;
        var tempCl = angular.copy(this.tempCheckList[variableName]);
        if (angular.isDefined(tempCl) && tempCl.length > index) {
            tempCl.splice(index, 0, { q: '', answer: '', editMode: true });
            this.backupCheckListItem = angular.copy({ q: '', answer: '', editMode: false });
        }
        this.editCl = false;
        this.tempCheckList[variableName] = angular.copy(tempCl);
    };
    /**
      addRb - Adds a radio button question on the last position
      @param {string} radioButtonName:   name of the radio button object
    */
    ColumnsEditController.prototype.addRb = function (radioButtonName) {
        var tempIndex = 0;
        angular.forEach(this.tempCheckList[radioButtonName].rb, function (radioButton) {
            if (angular.isDefined(radioButton.value)) {
                if (tempIndex < radioButton.value) {
                    tempIndex = radioButton.value;
                }
            }
        });
        tempIndex++;
        this.tempCheckList[radioButtonName].rb.push({ name: '', value: tempIndex });
    };
    /**
      clearRb - Clears the selection of any of those items
      @param {string} radioButtonName:   name of the radio button object
    */
    ColumnsEditController.prototype.clearRb = function (radioButtonName) {
        this.tempCheckList[radioButtonName].picked = '';
    };
    /**
      removeRbItem - Removes the radiobutton option from the index position
      @param {string} radioButtonName:    name of the radio button object
      @param {number} index:              position of the radiobutton that will be removed
    */
    ColumnsEditController.prototype.removeRbItem = function (radioButtonName, index) {
        if (angular.isDefined(this.tempCheckList[radioButtonName].rb) && !(this.tempCheckList[radioButtonName].rb.length - 1 < index)) {
            this.tempCheckList[radioButtonName].rb.splice(index, 1);
        }
    };
    ColumnsEditController.$inject = ['env', '$filter', 'DTS', '$stateParams', '$state',
        'socket', '$scope', 'config', 'admin', '$timeout', 'Dialog', '$q', 'settings', 'notify'];
    return ColumnsEditController;
}());
var ColumnsEditComponent = (function () {
    function ColumnsEditComponent() {
        this.templateUrl = 'columns.html';
        this.controllerAs = 'vm';
        this.controller = ColumnsEditController;
    }
    return ColumnsEditComponent;
}());
angular
    .module('application')
    .component('adminColumnsSection', new ColumnsEditComponent());

//# sourceMappingURL=columns.edit.component.js.map
